import { inject, Injectable } from "@angular/core";
import { GlossSyncService } from "../../gloss.sync.service";
import { DataRepositoryService } from "../../../DataRepository/data-repository.service";
import { GlossApiProxyRequest } from "../../../../shared/utils/helper.glos-api-call/gloss-api-proxy-request";
import { BasiqConfigType } from "@bitwarden/web-vault/app/models/types/environement-config.type";
import {
  BasiqConnection,
  GlossBasiqTokenResponse,
  GlossConnectionRefreshResponse,
} from "@bitwarden/web-vault/app/models/types/basiq.types";

const basiqConfig = process.env.BASIQ as unknown as BasiqConfigType;

@Injectable({
  providedIn: "root",
})
export class BasiqApi {
  protected readonly glossApiUrl: string;

  constructor(
    protected dataRepositoryService: DataRepositoryService = inject(DataRepositoryService),
    protected readonly glossSyncService: GlossSyncService = inject(GlossSyncService),
  ) {
    this.glossApiUrl = `${basiqConfig.url}/${basiqConfig.apiStage}`;
  }

  async getProxyGlossApi(data: any) {
    try {
      const glossRequestObject = new GlossApiProxyRequest(data);
      return await this.dataRepositoryService.send(
        glossRequestObject.method,
        glossRequestObject.path,
        glossRequestObject.data,
        glossRequestObject.authed,
        glossRequestObject.hasResponse,
        glossRequestObject.url,
        glossRequestObject.alterHeaders,
      );
    } catch (error) {
      await this.glossSyncService.logError(
        [],
        error,
        `Http call for ${JSON.stringify(data)}`,
        null,
      );
      throw error;
    }
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
